import React from 'react'
import Breadcrumb from '../components/Breadcrumbs'
import { Link } from 'react-router-dom'

function Accessories() {
    return (
        <div>
            <Breadcrumb title="ID Card Accessories" subtitle="Accessories" />
            
            <section className="service-grid-area pt-120 pb-90">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-12">
                            <div className="section-title text-center mb-50">
                                <h6 className="subtitle">Wearables & Protection</h6>
                                <h2 className="title">Complete Your Identification System</h2>
                                <p>High-quality lanyards, holders, and reels to display and protect your ID cards.</p>
                            </div>
                        </div>
                    </div>

                    <div className="row gy-4">
                        {/* Lanyards */}
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="catalog-card mb-30">
                                <div className="catalog-card-img">
                                    <img src="assets/imgs/accessories/lanyards.png" alt="Lanyards" />
                                </div>
                                <div className="catalog-card-content">
                                    <h4><Link to="/contact?interest=Lanyards">Lanyards</Link></h4>
                                    <p>Standard and custom-printed lanyards in various widths, colors, and attachments.</p>
                                    <Link to="/contact?interest=Lanyards" className="more-btn">Get Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                        {/* Badge Reels */}
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="catalog-card mb-30">
                                <div className="catalog-card-img">
                                    <img src="assets/imgs/accessories/badge-reel.png" alt="Badge Reels" />
                                </div>
                                <div className="catalog-card-content">
                                    <h4><Link to="/contact?interest=Badge+Reels">Badge Reels</Link></h4>
                                    <p>Retractable badge reels for easy card scanning and access.</p>
                                    <Link to="/contact?interest=Badge+Reels" className="more-btn">Get Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                         {/* Card Holders */}
                         <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="catalog-card mb-30">
                                <div className="catalog-card-img">
                                    <img src="assets/imgs/accessories/card-holder.png" alt="Card Holders" />
                                </div>
                                <div className="catalog-card-content">
                                    <h4><Link to="/contact?interest=Card+Holders">Card Holders</Link></h4>
                                    <p>Rigid, flexible, and eco-friendly card holders in landscape and portrait orientations.</p>
                                    <Link to="/contact?interest=Card+Holders" className="more-btn">Get Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    )
}

export default Accessories
